<template>
  <div v-if="content" v-editable="content" id="scolaires">
    <component :content="blok" :key="blok._uid" v-for="blok in content.body" :is="blok.component"></component>
  </div>
</template>

<script>
import api from "@/api";
import VueMarkdown from "vue-markdown";

export default {
  components: {
    VueMarkdown
  },
  data() {
    return {
      content: null
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      const res = await api.get(
        `cdn/stories/${this.$i18n.locale}/pages/scolaires`
      );
      this.content = res.data.story.content;
    }
  }
};
</script>

<style lang="scss">
#scolaires {
  .btn-list {
    .list {
      //background-color: $primary-D;
      border-radius: 15px;
      width: 600px;
      max-width:95%;
      margin-bottom: 30px;
    }
  }
}
</style>
